// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__9XXlW","description":"default_description__udoJ-","control":"default_control__FTpsj","link":"default_link__LQ6im"};